import { render, staticRenderFns } from "./ClientDistrictBadges.vue?vue&type=template&id=38c94f82&scoped=true&"
import script from "./ClientDistrictBadges.vue?vue&type=script&lang=js&"
export * from "./ClientDistrictBadges.vue?vue&type=script&lang=js&"
import style0 from "./ClientDistrictBadges.vue?vue&type=style&index=0&id=38c94f82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c94f82",
  null
  
)

export default component.exports